<template>
  <asc-dialog
    class="asc-create-powerbi-dashboard-dialog--container"
    :show-title="true"
    :show-dialog="showDialog"
    :on-close="handleClose"
    text="ARE YOU SURE?"
    full-width-buttons
    :width="400"
    :on-primary="onPrimaryClicked"
    :on-secondary="onSecondaryClicked"
    secondary-button-text="Cancel"
    primary-button-text="Delete"
  >
    <div v-html="getHtml"></div>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'

export default {
  name: 'AscDeletePowerBiReportDialog',
  components: {
    AscDialog,
  },
  mixins: [AscDialogMixin],
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    reportName: {
      type: String,
      default: '',
    },
  },
  computed: {
    getHtml() {
      return `Are you sure you want to permanently delete "${this.reportName}"?`
    },
  },
  methods: {
    onSecondaryClicked() {
      this.$emit('onCancelDeleteDialog')
    },
    onPrimaryClicked() {
      this.$emit('onDeleteDeleteDialog')
    },
    handleClose() {
      this.$emit('onCancelDeleteDialog')
    },
  },
}
</script>

<style lang="scss"></style>
